// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  ffActive: true,
  simSwapActive: true,
  versionCheckURL: '../inicio/assets/config/version.json',
  knowledgeBase_user: 'adminfinder',
  knowledgeBase_pw: 'finder2018',
  timerCheckVersion: 5, // cada 30 minutos
  FacebookId: '200854648325258',
  VersionFacebook: 'v4.0',
  GoogleId: '797801414770-12tqbuvu5qidb706556ko7rgfqfte4gt.apps.googleusercontent.com',
  UrlOrigen: window.location.protocol + '//' + window.location.hostname +(window.location.port? ':' + window.location.port: '') + '/inicio',   //https://www.virginmobile.co/inicio', // prueba locales
  NEW_SELFCARE_URL: 'https://www.virginmobile.co',
  ApiGoogleMaps: 'AIzaSyDbmObgYf305xssDoV0v9Q7pQ6ddbh2PLQ',
  countRequiredProductAditional: 1,
  accessKey: '977a9e14-0a83-40e9-941c-58d5087e84d2',
  yunoPublicKeySandbox: 'sandbox_gAAAAABoejjDiIprQ6hW7RplHTWOisjB3nhORoFWqcyYS5nDOye0EKcN1xVVJDYTUyv0rJw1__fZT_1CV3H0v8UvvNIJUEDYepJkuVTT8urXSv9WB4sG3mh8oBISp4uAzKNhi3LvQUKlRThlQBZeC9Sw1XNbexPNDP-zhlf9X9NcPFLLAnp8zFcqIzSNY8dddEa1xVh2MhwNydJwp4dFZKbcizuFtDL8WB0NVG6wY425cI5rcFuU9RIhkzIu3DUq2B6vV3g1B8LO',
  yunoPublicKeyProduction: 'prod_gAAAAABoejjDfQw45HNM3LIHnRLt-JopwBfSf2b0ZAU-EpcdJRZS_CCnAyL4sk8R9T37Py0J70JDqjhSyA32hhTzM8Q9ahCCfKudDOHdFoAEZ3hR3jp3oaiJ_eSihsdnaX9PJMhe9mUTBnQsYUM9CaenKf3sYfRWzvwhZWoyVHBOCRtaH-fLQXWF5Xo5jg9qm3PBhcZUK1-uu0XUtdfFHi22NkLAdv5rFocuVeM0ByTJ6sTrFO9You4jLWay0X1Yv2o6K0q7C-UU',
  yunoTenantId: 'CO',
  selfcareWidgetHost: 'https://dev-selfcare.virginmobile.co',
  esimWidgetUrl: 'https://dlcl68xyimx7x.cloudfront.net/vmla-esim-widget.js',
  showPromotionalCode: true
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
